import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import plPL from "antd/locale/pl_PL";
import { lightColors } from "../../../styles/theme/colors";
import { AppTheme } from "../../../styles/theme/theme.types";
import { getAntdTheme } from "../../../styles/theme/antdTheme";

const lightTheme: AppTheme = {
  mode: "light",
  colors: lightColors,
};

interface AuthLayoutProps {
  children: React.ReactNode;
  maxWidth?: number;
}

const StyledLayout = styled.div`
  height: 100vh;
  height: 100dvh;
  background: var(--color-green-dark, #1E363C);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  position: relative;
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  overflow-y: auto;

  @media (max-width: 768px), (max-height: 800px) {
    justify-content: flex-start;
  }
`;

const ContentCard = styled.div<{ maxWidth: number }>`
  width: 100%;
  max-width: ${(props) => props.maxWidth}px;
  position: relative;
  z-index: 1;
  margin: 0 auto;
`;

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, maxWidth = 540 }) => {
  return (
    <StyledLayout>
      <ContentCard maxWidth={maxWidth}>
        {children}
      </ContentCard>
    </StyledLayout>
  );
};
